// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3hNBS","obliqueLineWrap":"membershipbadge_obliqueLineWrap__26OST","obliqueLine":"membershipbadge_obliqueLine__XzhFL"};